
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/competency-assessment",
      function () {
        return require("private-next-pages/competency-assessment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/competency-assessment"])
      });
    }
  